/**
 * GET THE FORM STATE ('create' / 'edit' / 'duplicate')
 * It check the the route name to find a matching word
 * Return the state founded in the route name, by default it's 'create'
 */

export default {
  methods: {
    getFormState () {
      const route = this.$route;
      let state = 'create';
      if(route.name.includes('create')) {
          state = 'create';
        } else if(route.name.includes('duplicate')) {
          state = 'duplicate';
        } else if(route.name.includes('edit')) {
          state = 'edit';
        }
      return state;
    }
  }
}
